<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllTours"></b-form-checkbox>
        <span @click="checkedAllTours = !checkedAllTours">Komoot Tours</span>
        <div style="float: right;">
          <img @click="expanded = !expanded" style="height: 13px; cursor: pointer;" :src="expanded ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expanded">
        <b-form-checkbox class="display-inline marginright5" v-model="active"></b-form-checkbox>
        <span @click="active = !active">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactive"></b-form-checkbox>
        <span @click="inactive = !inactive">Inactive</span>
      </div>
    </div>
    <br>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllPhotos"></b-form-checkbox>
        <span @click="checkedAllPhotos = !checkedAllPhotos">Komoot Tour Photos</span>
        <div style="float: right;">
          <img @click="expandedPhotos = !expandedPhotos" style="height: 13px; cursor: pointer;" :src="expandedPhotos ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expandedPhotos">
        <b-form-checkbox class="display-inline marginright5" v-model="activePhotos"></b-form-checkbox>
        <span @click="activePhotos = !activePhotos">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactivePhotos"></b-form-checkbox>
        <span @click="inactivePhotos = !inactivePhotos">Inactive</span>
      </div>
    </div>
    <MapPlace v-for="place of $store.state.maplasPlaces[$DataOrigin.komoottour]" :key="place.id" :place="place"></MapPlace>   
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import Place from '@/ts/Place';
import Photo from '@/ts/Photo';
import PlaceType from '@/ts/PlaceType';
import { AlertStatus, DataOrigin, DownloadStatus } from '@/ts/types';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const checkedAllPhotos: boolean = false;
        const checkedAllTours: boolean = false;

        return {
            checkedAllTours,
            expanded: false,
            active: true,
            inactive: false,
            checkedAllPhotos,
            expandedPhotos: false,
            activePhotos: true,
            inactivePhotos: false,
            loading: false
        };
    },
    created() {
      EventBus.$on('downloadExternalData', () => this.downloadToursKomoot());
      EventBus.$on('toggleKomootTours', () => {
        if (this.$options.result) {
          this.checkedAllTours = !this.checkedAllTours
        }
      });
      EventBus.$on('toggleKomootToursPhotos', () => {
        if (this.$options.result) {
          this.checkedAllPhotos = !this.checkedAllPhotos
        }
      });
      EventBus.$on('selectedAreaChanged', (newArea: string, oldArea: string) => this.onSelectedAreaChanged(newArea, oldArea));
    },
    methods: {
      isPointInSelectedArea(lat: number | string, lon: number | string) {
        // @ts-ignore
        const areaKey = window.selectedArea;
        if (!areaKey) return true;
        // @ts-ignore
        const area = window.areas[areaKey];
        if (!area || !area[0] || !area[1]) return true;
        const minLat = Math.min(area[0][0], area[1][0]);
        const maxLat = Math.max(area[0][0], area[1][0]);
        const minLon = Math.min(area[0][1], area[1][1]);
        const maxLon = Math.max(area[0][1], area[1][1]);
        const plat = Number(lat);
        const plon = Number(lon);
        if (Number.isNaN(plat) || Number.isNaN(plon)) return false;
        return (plat >= minLat && plat <= maxLat && plon >= minLon && plon <= maxLon);
      },

      isPathInSelectedArea(path: any[]) {
        if (!path || !path.length) return false;
        for (const p of path) {
          if (Array.isArray(p) && p.length >= 2) {
            if (this.isPointInSelectedArea(p[0], p[1])) return true;
          } else if (p && typeof p === 'object') {
            const lat = p.lat ?? p.latitude ?? p[0];
            const lon = p.lon ?? p.lng ?? p.longitude ?? p[1];
            if (lat !== undefined && lon !== undefined && this.isPointInSelectedArea(lat, lon)) return true;
          }
        }
        return false;
      },

      onSelectedAreaChanged(newArea: string, oldArea: string) {
        if (this.$options.places) {
          for (const place of this.$options.places) {
            try { place.getMarker().removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.cycleways) {
          for (const cycleway of this.$options.cycleways) {
            try { cycleway.removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.result) {
          this.processToursKomoot();
        }
      },
        downloadToursKomoot() {
            this.loading = true;
            const endPoint = window.apiHost + 'api/stringfield/komoottours/';
            this.downloadUrlWithCache(endPoint, 'komoottours', 'komoottours.txt', null, true).then((response) => {
              this.$options.result = response[1].results;
              if (response[0] == DownloadStatus.cache_fresh) {
                this.createAlert(AlertStatus.success, this.$t('toursLoaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.api_fresh) {
                this.createAlert(AlertStatus.success, this.$t('toursDownloaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.cache_last) {
                this.createAlert(AlertStatus.warning, this.$t('toursLoaded', [response[1].results.length]).toString(), 2000);
              }
            }).catch((error) => {
              this.createAlert(AlertStatus.danger, this.$t('toursError').toString(), 2000);
            }).finally(() => {
              this.loading = false;
            });
        },
        processToursKomoot() {
            const tours: any[] = [];
            const places: Place[] = [];
            const other_type = new PlaceType(1000001, 'other', {'color': 'red'}, 1);
            for (const responseTour of this.$options.result) {
              const cycleway = new L.Polyline(responseTour['points'], {
                color: 'red',
                weight: 3,
                opacity: 1,
                smoothFactor: 1,
              });
              cycleway.is_active = responseTour.is_active;
              const imageMarkres: L.CircleMarker[] = [];
              for (const image of responseTour['images']) {
                const marker = new L.CircleMarker([image.lat, image.lon], {radius: 6, color: 'blue'});
                if (window.window.isDesktop) {
                  marker.on('click', () => {
                    window.open('https://www.komoot.com/pl-pl/tour/' + responseTour['id'] + '/zoom', '_blank').focus();
                    window.open('https://www.komoot.com/pl-pl/tour/' + responseTour['id'], '_blank').focus();
                  })
                }
                imageMarkres.push(marker);
                const place = new Place(image.id, image.id, '', image.lat.toFixed(5), image.lon.toFixed(5), other_type, false, null, DataOrigin.komoottour, cycleway.is_active);
                place.createMarker();
                const photo = new Photo(1000000, 'Photo', '', image.id, null, window.mediaHost + 'komoot_tour/' + image.id + '.jpg', window.mediaHost + 'komoot_tour/' + image.id + '.jpg', window.mediaHost + 'komoot_tour/' + image.id + '_thumb_300.jpg', false, 1, false);
                place.addPhoto(photo);
                // include place only if inside selected area
                if (this.isPointInSelectedArea(place.lat, place.lon)) {
                  places.push(place);
                }
              }
              cycleway.on('mouseover', () => {
                cycleway.setStyle({'color': 'yellow'});
                cycleway.bringToFront();
                for(const marker of imageMarkres) {
                  marker.addTo(window.mainmap);
                }
              });
              cycleway.on('mouseout', () => {
                cycleway.setStyle({'color': 'red'});
                for(const marker of imageMarkres) {
                  marker.removeFrom(window.mainmap);
                }
              });
              if (window.window.isDesktop) {
                cycleway.on('click', () => {
                  window.open('https://www.komoot.com/pl-pl/tour/' + responseTour['id'] + '/zoom', '_blank').focus();
                  window.open('https://www.komoot.com/pl-pl/tour/' + responseTour['id'], '_blank').focus();
                })
              }
              // include cycleway if any point in it is inside the selected area
              if (this.isPathInSelectedArea(responseTour['points'])) {
                tours.push(cycleway);
              }
            }
            this.$options.cycleways = tours;
            this.$options.places = places;
            window.externalPlaces.komoottour = this.$options.places;
            this.onCheckedAllToursChanged();
            this.onCheckedAllPlacesChanged();
        },
        onCheckedAllToursChanged() {
            if (this.$options.cycleways) {
              for(const tour of this.$options.cycleways) {
                if (this.checkedAllTours) {
                  if (tour.is_active) {
                    if (this.active) {
                      tour.addTo(window.mainmap);
                    } else {
                      tour.removeFrom(window.mainmap);
                    }
                  } else {
                    if (this.inactive) {
                      tour.addTo(window.mainmap);
                    } else {
                      tour.removeFrom(window.mainmap);
                    }
                  }
                } else {
                  tour.removeFrom(window.mainmap);
                }
              }
            } else {
              this.processToursKomoot();
            }
        },
        onCheckedAllPlacesChanged() {
            if (this.$options.places) {
              for(const place of this.$options.places) {
                if (this.checkedAllPhotos) {
                  if (place.is_active) {
                    if (this.activePhotos) {
                      place.getMarker().addTo(window.mainmap);
                    } else {
                      place.getMarker().removeFrom(window.mainmap);
                    }
                  } else {
                    if (this.inactivePhotos) {
                      place.getMarker().addTo(window.mainmap);
                    } else {
                      place.getMarker().removeFrom(window.mainmap);
                    }
                  }
                } else {
                  place.getMarker().removeFrom(window.mainmap);
                }
              }
            } else {
              this.processToursKomoot();
            }
        }
    },
    watch: {
        "checkedAllTours": [{
            handler: "onCheckedAllToursChanged"
        }],
        "active": [{
            handler: "onCheckedAllToursChanged"
        }],
        "inactive": [{
            handler: "onCheckedAllToursChanged"
        }],
        "checkedAllPhotos": [{
            handler: "onCheckedAllPlacesChanged"
        }],
        "activePhotos": [{
            handler: "onCheckedAllPlacesChanged"
        }],
        "inactivePhotos": [{
            handler: "onCheckedAllPlacesChanged"
        }]
    }
})


</script>